var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Migration Early Start ")]),
      _c("gg-card-text", [
        _c(
          "p",
          {
            staticClass: "mb-1"
          },
          [
            _vm._v(
              " Your migration can now be started on your own schedule. Click the button below to queue your migration. "
            )
          ]
        ),
        _c(
          "p",
          {
            staticClass: "mb-1"
          },
          [
            _vm._v(
              " Make sure no website or database changes occur until your migration is completed and you have allowed time for DNS propagation. "
            )
          ]
        ),
        _c("p", [
          _vm._v(
            " If you do not start your migration early, your migration will be processed automatically on " +
              _vm._s(_vm.migration.scheduled_for) +
              ". "
          )
        ]),
        _c(
          "div",
          {
            staticClass: "flex-column gap-1"
          },
          [
            _c("v-checkbox", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function fn() {
                    return [
                      _vm._v(
                        " I confirm I am ready to start the migration. I understand the migration will be processed immediately and that I should make no changes during the migration. "
                      )
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.confirmation,
                callback: function callback($$v) {
                  _vm.confirmation = $$v
                },
                expression: "confirmation"
              }
            }),
            _c(
              "gg-btn",
              {
                attrs: {
                  disabled: !_vm.confirmation,
                  loading: _vm.loading
                },
                on: {
                  click: _vm.startMigration
                }
              },
              [_vm._v(" Start Migration ")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }